module.exports = "pegasus/assets/glyphicons-halflings-white.png";